import * as types from './types'

export default {
  [types.SET_USER_CONFIG] (state, payload) {
    state.userInfo = {...state.userInfo, ...payload}
  },
  [types.SET_VERSION] (state, payload) {
    state.version = payload
  },
  [types.SET_SHARE_DOMAIN] (state, payload) {
    state.shareDomain = payload
  },
  [types.SET_PWD_TEMP] (state, payload) {
    state.pwdTempData = payload
  },
  [types.SET_MAIN_ACT] (state, payload) {
    state.mainActData = payload
  },
  [types.SET_ACTIVITY_CONFIG] (state, payload) {
    state.activityConfig = {...state.activityConfig, ...payload}
  },
  showPosterModal (state) {
    state.isShowPosterModal = true
  },
  hidePosterModal (state) {
    state.isShowPosterModal = false
  },
  showCopyModal (state, payload) {
    state.copyModalData = {
      isShow: true,
      text: payload.text,
      showBtn: payload.showBtn
    }
  },
  hideCopyModal (state) {
    state.copyModalData = {
      isShow: false,
      text: ''
    }
  },
  showSignModal (state, payload) {
    state.signModalData = {
      isShow: true,
      ...payload,
    };
  },
  hideSignModal (state) {
    state.signModalData = {
      isShow: false,
    }
  },
  [types.SET_TJB_CONFIG] (state, payload) {
    state.yhTjb = {...state.yhTjb, ...payload}
  },
}
